<template>
  <div class="material-list" v-bind="$attrs">
    <div
        v-for="item in materialList"
        :key="item.id"
        class="material-list-body"
        :style="{ ...styleBody }"
    >
      <div class="material-list-main">

        <div class="material-list-container">
          <div class="image-container" @click="toDetail(item)">
            <div style="width: 75%;height: 100%;background-color: #fff;overflow: hidden" v-if="item.m_type === 'text'">
              <div style="transform: scale(0.6);word-break: break-all;transform-origin:top;">{{ item.m_content }}</div>
            </div>
            <div v-else-if="item.m_type === 'video'"
                 style="width: 100%;height: 100%;text-align: center;position: relative">
              <img :src="item.img_url || item.m_url" alt="" style="max-width: 100%;max-height: 100%"/>
              <a-icon type="play-circle"
                      style="position: absolute;top:50%;left:50%;transform:  translate(-50%,-50%);color:var(--main-color);font-size: 24px;"/>
            </div>
            <img v-else-if="item.m_type === 'docs'" :src="matchLogo(item.m_ext_type)" alt="">
            <img :src="item.img_url || item.m_url" alt="" v-else/>

          </div>
          <div class="material-list-container-right">
            <div>
              <div style="display: flex;justify-content: space-between">
                <div v-if="item.m_name_cn" :title="item.m_name_cn" class="material-name">
                  {{ item.m_name_cn }}
                  <a-divider type="vertical"/>
                  ID:{{ item.id }}
                </div>
                <div class="material-opt" style="display: flex;justify-content: flex-end">
                  <a-checkbox :checked="item.isSelect" @change="onChange(item)"></a-checkbox>
                </div>
              </div>
              <slot name="title" :item="item">

              </slot>
            </div>

            <div class="material-info">
              <div>{{ $t('message.materialLibrary.type') }}：{{ item.m_type_name }}</div>
              <div>{{ $t('message.materialLibrary.Format') }}：{{ item.m_ext_type }}</div>
            </div>
            <div class="material-list-footer">
            <span
                v-if="showEdit"
                style="color: var(--main-color)"
                @click="showEditModal(item)"
            >
              {{ $t('message.commonUsage.edit') }}
            </span>

              <a-popconfirm
                  :title="$t('message.materialLibrary.ConfirmDelete')"
                  :ok-text="$t('message.commonUsage.confirm')"
                  :cancel-text="$t('message.commonUsage.cancel')"
                  @confirm="confirmDelete(item)"
                  v-if="showDel"
              >
                <span style="color: var(--main-color)">{{ $t('message.commonUsage.delete') }}</span>
              </a-popconfirm>
              <span v-if="showDownload" style="color: var(--main-color)" @click="down(item)"
              >{{ $t('message.materialLibrary.download') }}</span
              >
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import {matchFileLogo} from "@/utils/common";

export default {
  name: "materialCard",
  components: {},
  props: {
    treeData: Array,
    checkedData: Array,
    styleBody: Object,
    showDownload: {
      type: Boolean,
      default: false,
    },
    showDel: {
      type: Boolean,
      default: true
    },
    showEdit: {
      type: Boolean,
      default: false,
    },
    moreHeader: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      materialList: [],
      checkedList: []
    };
  },
  methods: {
    matchLogo(name) {
      return matchFileLogo(name)
    },
    confirmDelete(i) {
      this.$emit("del", i);
    },
    showEditModal(i) {
      this.$emit("edit", i);
    },
    down(i) {
      this.$emit("download", i.m_type === 'image' ? i.img_url : i.m_orgin_url);
    },
    onChange(i) {
      if (!this.multiple) {
        this.materialList.forEach(item => item.isSelect = false)
      }
      i.isSelect = !i.isSelect;

      const obj = this.checkedList.find(item => item.m_id === i.m_id)
      if (!obj && i.isSelect) {
        if (!this.multiple) {
          this.checkedList = []
        }
        this.checkedList.push(i)
      }
      if (obj && !i.isSelect) {
        this.checkedList = this.checkedList.filter(item => item.m_id !== i.m_id)
      }
      this.checkedList = this.checkedList.filter(item => item.isSelect)
      this.$emit("sync", JSON.parse(JSON.stringify(this.materialList)), i);
    },
    toDetail(i) {
      this.$emit("showDetail", i);
    },
  },
  computed: {},
  watch: {
    treeData: {
      handler(v) {
        const value = JSON.parse(JSON.stringify(v))
        this.checkedList.forEach(i => {
          const index = value.findIndex(item => item.m_id === i.m_id)
          if (index !== -1) {
            value[index] = i
          }
        })
        this.materialList = value;

      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped lang="less">
.material-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  .material-list-body {
    flex: 1;
    margin: 0 5px 5px 0;
    width: calc((100% - 10px) / 3);
    min-width: calc((100% - 10px) / 3);
    max-width: calc((100% - 10px) / 3);
    padding: 0 12px;
    background-color: white;
    cursor: pointer;
    overflow: hidden;

    &:nth-child(3n) {
      margin-right: 0;
    }

    &:hover {
      background: #f5f5f5;
    }

    .material-list-main {
      padding: 8px;

      .material-list-title {
        display: flex;
        justify-content: space-between;

        p {
          margin: 0;
        }

        .material-opt {
          display: flex;
          justify-content: space-between;
          grid-gap: 5px;

          ::v-deep .ant-select-selection__rendered, ::v-deep .ant-select-selection--single {
            height: 20px;
            line-height: 20px;
          }
        }
      }

      .material-list-container {
        display: flex;
        margin: 10px 0;

        .image-container {
          width: 104px;
          height: 104px;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          background-image: linear-gradient(45deg,
          rgba(0, 0, 0, 0.05) 25%,
          transparent 25%,
          transparent 75%,
          rgba(0, 0, 0, 0.05) 75%,
          rgba(0, 0, 0, 0.05) 100%),
          linear-gradient(45deg,
          rgba(0, 0, 0, 0.05) 25%,
          transparent 25%,
          transparent 75%,
          rgba(0, 0, 0, 0.05) 75%,
          rgba(0, 0, 0, 0.05) 100%);
          background-size: 10px 10px;
          background-position: 0 0, 5px 5px;
        }

        img {
          max-width: 104px;
          max-height: 104px;
          cursor: pointer;
        }

        &-right {
          flex: 1;
          padding-left: 8px;
          display: flex;
          flex-direction: column;
          max-width: calc(100% - 104px);

          .material-list-footer {
            display: flex;
            justify-content: flex-end;
            grid-gap: 15px;
          }

          div:not(.material-name) {
            flex: 1;
          }

          .material-name {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            font-weight: bold;
            width: 250px !important;
          }

          .material-info {
            display: flex;

            div {
              flex: 1;
            }
          }
        }
      }


    }
  }
}
</style>
